import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled, { css } from 'styled-components';
import { Column, Grid } from '../../components';
import Config from '../../config';
/**
 * Additional prop `noGutterY` added to
 * remove vertical gutter space in the grid
 *
 * TODO: Add this enhancement in the Grid component.
 */

var NoGutterYGrid = styled(Grid).withConfig({
  displayName: "NoGutterYGrid",
  componentId: "sc-1o2nocl-0"
})(["", ";", ""], Config.media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      padding: ", ";\n    "])), function (p) {
  return p.noGutterY ? "0 ".concat(Config.grid.outerMargin / 2, "rem") : "".concat(Config.grid.outerMargin / 2, "rem");
}), function (p) {
  return p.noGutterY && css(["padding-top:0;padding-bottom:0;", "{padding-top:0;padding-bottom:0;}"], /* sc-selector */
  Column);
});
export default NoGutterYGrid;